export const API_URL = 'https://api.cadedireito.com.br/v1';